<template>
  <div id="iiko-page">
    <h1 class="title is-2">{{ $t('Iiko.title') }}</h1>
    <div class="card ">
      <div class="card-content">
        <div class="block">
          <div class="field mt-2">
            <p class="note mb-4"><span v-html="$t('Iiko.iikoNote')"></span></p>
            <button v-if="this.place.integrations && this.place.integrations.includes('iiko') && !changeApi" v-bind:class="{ isLoading: isLoading }" class="button is-light mt-2"
              @click="changeApi = true">{{ $t('Iiko.changeApi') }}</button>
              
            <div v-else class="card" style="max-width:800px;">
              <div class="card-content" style="background-color: #a5dafb;border-radius: 6px;">
                <h1 class="title is-4">{{ $t('Iiko.authorization') }} </h1>
            
            
                <b-input class="order-email" placeholder="API-логин" style="max-width:400px; margin-bottom:1rem;"
                  type="text" v-model="gateway.user_id" />
                <b-input class="order-email" placeholder="API-пароль" style="max-width:400px; margin-bottom:1rem;"
                  type="text" v-model="gateway.user_secret" />
                <p class="note mt-4"><span v-html="$t('Iiko.iikoNote2')"></span></p>
                <button 
              v-bind:class="{ isLoading: isLoading }" class="button is-info mt-2 "
              @click="saveIntegration()">{{ $t('Iiko.connectIiko') }}</button>
              </div>
            </div>
            
            
          </div>
        </div>
      </div>
    </div>
    <div class="field mt-2">
      <b-switch v-model="menuSync" :disabled="typeof place.menuSync !== 'string'"
        @input="(value) => updateMenuSync(value)" name="switchRoundedSuccess" type="is-success">
      </b-switch>
      <label for="switchRoundedSuccess">{{ $t('Iiko.syncMenu') }}</label>
    </div>
    <div class="field mt-2">
      <b-switch v-model="ordersPush" :disabled="typeof place.menuSync !== 'string'"
        @input="(value) => updateOrdersPush(value)" type="is-success">
      </b-switch>
      <label for="switchRoundedSuccess">{{ $t('Iiko.sendOrders') }}</label>
    </div>

    <button v-if="this.place.integrations && this.place.integrations.includes('iiko')"
      v-bind:class="{ isLoading: isLoading }" class="button is-info mt-2"
      @click="manualMenuSync()">{{ $t('Iiko.syncManually') }}</button>


  </div>

</template>

<script>
        
import _ from "underscore";
import {
  mapActions,
  mapGetters
} from "vuex";
import api from "@/api";

export default {
  name: "Iiko",
  components: {

  },
  props: [],
  computed: _.extend({},
    mapGetters({
      place: "getPlaceInfo"
    })
  ),

  data() {
    return {
      isLoading: false,
      menuSync: false,
      ordersPush: false,
      gateway: {},
      changeApi: false
    }
  },

  methods: _.extend({}, mapActions(["populatePlaceInfo", "updatePlaceInfo"]), {
    connectIiko: function () {
      this.$buefy.dialog.confirm({
        message: this.$t('Iiko.dialogConnectIikoMessage'),
        title: this.$t('Iiko.title'),
        type: 'is-success',
        confirmText: this.$t('Dashboard.yes'),
        cancelText: this.$t('Dashboard.back'),
        onConfirm: () => {
          this.$ma.trackEvent({
            category: 'event',
            action: 'Connection with Iiko started',
            label: null,
            value: null
          })
          let params = this.gateway;
          params.gatewayName = "iiko"
          params.url = this.place.url
          api.updateIntegrationDetails(params).then((resp) => {
            console.log('updateIntegrationDetails:', resp);
            this.saveInfo()
            this.loading = false
          })
        },
        onCancel: () => {
          this.$ma.trackEvent({
            category: 'event',
            action: 'Connection with Iiko cancelled',
            label: null,
            value: null
          });
        }
      })

    },
    saveIntegration() {
      this.isLoading = true
      let params = this.gateway;
      params.gatewayName = "iiko";
      params.identityId = this.place.identityId;
      params.url = this.place.url;
      api.updateIntegrationDetails(params).then((resp) => {
        console.log('updateIntegrationDetails:', resp);
        api.iikoSyncMenu({
          url: this.place.url,
        }).then((response) => {
          this.$cognitoAuth.refreshSession(options => {
          this.populatePlaceInfo(options).then(() => {

          this.isLoading = false
          this.place.menuSync = "iiko"
          if (this.place.integrations) {
            if (!this.place.integrations.includes("iiko"))
              this.place.integrations.push("iiko")
          } else this.place.integrations = ["iiko"]

          if (this.place.ordering.integrations) {
            if (!this.place.ordering.integrations.includes("iiko"))
              this.place.ordering.integrations.push("iiko")
          } else this.place.ordering.integrations = ["iiko"]

          this.saveInfo()
          this.$forceUpdate()
          this.ordersPush = true
          this.menuSync = true
          this.$buefy.dialog.alert({
            type: 'is-success',
            message: "Интеграция с Iiko произведена успешно. </br> Меню синхронизировано.",
            onConfirm: () => {this.$router.replace('/')}
          })
          
         
        })
        })          
        });
      })
    },
    manualMenuSync() {
      this.isLoading = true
      api.iikoSyncMenu({
        url: this.place.url
      }).then((response) => {
        this.isLoading = false
      })
    },
    saveInfo() {
      this.updatePlaceInfo(this.place).then(() => {
        this.$buefy.toast.open(this.$t('DashboardTable.saved'))
      });
    },
    updateMenuSync(value) {
      if (value)
        this.place.menuSync = 'iiko'
      else
        this.place.menuSync = 'NA'
      this.saveInfo()
    },
    updateOrdersPush(value) {
      if (value && !this.place.ordering.integrations.includes('iiko'))
        this.place.ordering.integrations.push('iiko')
      else
      if (this.place.ordering.integrations.includes('iiko'))
        this.place.ordering.integrations.splice(this.place.ordering.integrations.indexOf('iiko'), 1)
      this.saveInfo()
    }
  }),
  mounted() {
    window.onbeforeunload = function () {}
    this.$ma.trackEvent({
      category: 'event',
      action: 'Page viewed: ' + this.$route.fullPath,
      label: null,
      value: null
    })

    //If redirected back from after Iiko auth
    if (window.location.href.indexOf("account=") > -1) {
      this.isLoading = true
      let code = this.$route.query.code
      let account = this.$route.query.account
      console.log(code)
      api.connectPostman({
        code: code,
        url: this.place.url,
        account: account
      }).then((response) => {
        this.isLoading = false

        console.log(response)
        this.$cognitoAuth.refreshSession(options => {
          this.populatePlaceInfo(options).then(() => {
            this.place.ordering.integrations.pop("iiko")
            if (this.place.integrations) {
              if (!this.place.integrations.includes("iiko"))
                this.place.integrations.pop("iiko")
            } else this.place.integrations = ["iiko"]

            this.updatePlaceInfo(this.place)
            this.$forceUpdate()
          })

          this.$buefy.dialog.alert({
            type: 'is-success',
            message: "Интеграция с Iiko произведена успешно. </br> Меню синхронизировано."
          })
          this.ordersPush = true
          this.menuSync = true
          this.$router.replace('/')
        });
      });
    } else {
      if (this.place.ordering.integrations && this.place.ordering.integrations.includes('iiko'))
        this.ordersPush = true
      if (this.place.menuSync && this.place.menuSync == 'iiko')
        this.menuSync = true
    }
  }
};
</script>
